import { useDealerFlagTraits } from "@hooks/useDealerFlagTraits";
import {
  useDealerContextBootstrap,
  useEntitlementSync,
  useProfileRevalidation,
} from "@lyteflo/utils";
import type { ComponentChildren } from "preact";

interface DealerContextBootstrapProps {
  children: ComponentChildren;
}

export const DealerContextBootstrap = ({
  children,
}: DealerContextBootstrapProps) => {
  useProfileRevalidation();
  useDealerContextBootstrap();
  useEntitlementSync();
  useDealerFlagTraits();
  return <>{children}</>;
};
